import { OtherEnum } from "requests";

export const OTHER_FINDINGS_OPTIONS = [
  { value: OtherEnum.Ge, label: "GE" },
  { value: OtherEnum.Gh, label: "GH" },
  { value: OtherEnum.Ab, label: "AB" },
  { value: OtherEnum.At, label: "AT" }
];
